import languages from '../data/languages.json';

export const SUPPORTED_LANGUAGES = languages;

const EXCLUDED_PATHS = /^\/(admin(?:\/|$)|chat(?:\/|$)|password-reset(?:\/|$)|properties\/list(?:\/|$)|add-contact(?:\/|$))/;

export const shouldShowLanguageSwitcher = (pathname = '/') => !EXCLUDED_PATHS.test(pathname);
